import { configMt } from "../../constant/initDrawing";
import { useSocket } from "../../helpers/socket";
import Live2MTWrapper from "../../components/live2/mt/Live2MTWrapper";

const config = {
    ...configMt,
    type: "tn",
    subFixType: "minhngoc"
}

const Live2TN830Page = () => {
    const { socket } = useSocket({ platform: `tn_minhngoc_website` })
    return <Live2MTWrapper socket={socket} config={config} />
}

export default Live2TN830Page;